import { ExpressionType_InRange } from '../_entity/expression/index.js';
import { LogicType_BelowNormal, LogicType_InNormal } from '../_enum/atom-case-operator/index.js';
/**
 * Get A pre made in range expression for a variable of type standard range
 * @param variable Variable to create the expression for
 * @param value Value of the variable
 */
export const InRangeExpressionTemplate = (variable) => {
    return {
        expressionType: ExpressionType_InRange.dbKey,
        associatedVar: variable._id,
        isEvidenceBased: false,
        expression: 'T1',
        label: `${variable.name} - In Range`,
        terms: [{
                atoms: [{
                        leftHand: {
                            id: variable._id,
                            type: 'variable'
                        },
                        cases: [
                            {
                                caseOperator: LogicType_BelowNormal,
                                factor: { lower: 1, upper: 1 },
                                rightHand: [],
                                value: [-1, -1]
                            },
                            {
                                caseOperator: LogicType_InNormal,
                                factor: { lower: 1, upper: 1 },
                                rightHand: [],
                                value: [0, 0]
                            }
                        ],
                        fallbackValue: [1, 1]
                    }],
                expression: 'A1'
            }],
        outputType: 'numeric'
    };
};
//# sourceMappingURL=utils.js.map